import { render, staticRenderFns } from "./PolygonForm.vue?vue&type=template&id=7fd53389&"
import script from "./PolygonForm.vue?vue&type=script&lang=js&"
export * from "./PolygonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports